import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const studyHighlights = [
    {
        title: 'Increased ROI',
        description: 'Organizations leveraging JectHub AI solutions reported a significant return on investment (ROI) through improved efficiency and cost savings.',
    },
    {
        title: 'Accelerated Innovation',
        description: 'Companies using JectHub AI tools experienced faster time-to-market for AI-driven projects and innovations.',
    },
    {
        title: 'Talent Upskilling',
        description: 'JectHub’s AI learning ecosystem contributed to workforce development, bridging the AI skills gap and enhancing productivity.',
    },
    {
        title: 'Cost Reduction',
        description: 'Automating AI processes with JectHub significantly reduced operational costs, allowing businesses to allocate resources more effectively.',
    },
    {
        title: 'Enhanced Decision-Making',
        description: 'Data-driven insights from JectHub AI tools helped businesses make more informed and strategic decisions.',
    },
    {
        title: 'Improved Security & Compliance',
        description: 'AI-powered security solutions provided enhanced protection against cyber threats, ensuring regulatory compliance.',
    },
    {
        title: 'Scalability & Flexibility',
        description: 'JectHub AI solutions provided scalable and adaptable technologies suitable for organizations of all sizes.',
    },
    {
        title: 'Competitive Advantage',
        description: 'Businesses integrating JectHub AI solutions gained a significant competitive edge in their respective industries.',
    },
];

function TEIStudy() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Forrester Total Economic Impact (TEI) Study</Title>
                <Paragraph>
                    The Forrester Total Economic Impact (TEI) study evaluates the financial and strategic benefits of adopting JectHub AI solutions.
                    This study highlights the cost savings, business impact, and competitive advantages experienced by organizations leveraging JectHub.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {studyHighlights.slice(0, 4).map((highlight, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={highlight.title} bordered={false}>
                                <Paragraph>{highlight.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {studyHighlights.slice(4, 8).map((highlight, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={highlight.title} bordered={false}>
                                <Paragraph>{highlight.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default TEIStudy;
